import { InjectionToken } from '@angular/core';

export const FUSE_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>(
	'FUSE_MOCK_API_DEFAULT_DELAY'
);
